import { render, staticRenderFns } from "./step-category.vue?vue&type=template&id=d3489a6e&"
import script from "./step-category.vue?vue&type=script&lang=js&"
export * from "./step-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports